import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { itemGroupEntry } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const itemGroupEntrySlice = createSlice({
    name: itemGroupEntry,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetailParams: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetailParams } = itemGroupEntrySlice.actions;
export default itemGroupEntrySlice.reducer;
